import { IPlan, IPriceStructure } from ".";

export const starter: IPlan = {
  id: "starter",
  name: "Starter",
  description: "Build your first premium visual stories with everything you need to get started.",
  chargebee: new Set([
    "starter-monthly-aud",
    "starter-monthly-usd",
    "starter-monthly-eur",
    "starter-monthly-gbp",
    "starter-annual-aud",
    "starter-annual-usd",
    "starter-annual-eur",
    "starter-annual-gbp",
  ]),
  features: {
    "organisation-manage-publish-configurations": true,
    "organisation-team-leader-view": true,
    "organisation-team-limit": 1,
    "organisation-member-limit": 200,
    "organisation-team-member-limit": 200,
    "organisation-sites": true,
    "preview-banner": true,
    "page-settings-amp-enabled": false,
    "page-settings-analytics-ga": false,
    "page-settings-override-social-cover-url": true,
    "shorthand-analytics-tracking": true,
    "story-credits-required": false,
    "themes-demo": false,
    "publish-embed-ui": true,
    "story-comments": true,
    "foreground-animation": true,
  },
  marketing: {
    label: "Fast, simple publishing with Shorthand themes and hosting.",
    className: "plan-starter",
    benefits: ["Shorthand hosting", "Story embedding", "Shorthand Analytics", "Webinars and training"],
    storyInclusions: 12,
    seatInclusions: 1,
    prices: {
      planPrice: {
        monthly: { USD: 60 },
        yearly: { USD: 50 },
      },
      userAddonPrice: {
        monthly: { USD: 60 },
        yearly: { USD: 50 },
      },
      publishAddonPrice: {
        monthly: { USD: 60 },
        yearly: { USD: 60 },
      },
    } as IPriceStructure,
  },
};
